module.exports = __webpack_public_path__ + "static/img/guest49.0a23ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/guest49.png
// module id = Gwd2
// module chunks = 0